import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const MemberLocalePrefDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MemberLocalePref"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MemberHeader"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"MemberLocalePref","document":MemberLocalePrefDocument}} as const;
export type MemberLocalePrefQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
}>;


export type MemberLocalePrefQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id'>
    & { prefs?: Types.Maybe<(
      { __typename: 'Member_Prefs' }
      & Pick<Types.Member_Prefs, 'locale'>
    )> }
  )> }
);




/**
 * __useMemberLocalePrefQuery__
 *
 * To run a query within a React component, call `useMemberLocalePrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberLocalePrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberLocalePrefQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useMemberLocalePrefQuery(baseOptions: Apollo.QueryHookOptions<MemberLocalePrefQuery, MemberLocalePrefQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberLocalePrefQuery, MemberLocalePrefQueryVariables>(MemberLocalePrefDocument, options);
      }
export function useMemberLocalePrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberLocalePrefQuery, MemberLocalePrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberLocalePrefQuery, MemberLocalePrefQueryVariables>(MemberLocalePrefDocument, options);
        }
export type MemberLocalePrefQueryHookResult = ReturnType<typeof useMemberLocalePrefQuery>;
export type MemberLocalePrefLazyQueryHookResult = ReturnType<typeof useMemberLocalePrefLazyQuery>;
export type MemberLocalePrefQueryResult = Apollo.QueryResult<MemberLocalePrefQuery, MemberLocalePrefQueryVariables>;